import { 
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData, 
    addDataFactory 
} from "../../core";
import { IDashboardSharedViewModel, KeyedDimension, comorbidities } from "./viewModel";

export { comorbidities };

const IndexMap = {
    [comorbidities.zero.name]: 0,
    [comorbidities.one.name]: 1,
    [comorbidities.twoPlus.name]: 2, 
    [comorbidities.unknown.name]: 3
};

export function toColors(comorbities: string[], colors: string[]) {
    return comorbities.map(p => colors[IndexMap[p] || 0]);
}

/**
 * Maps the raw value to a Comorbidity enum value
 * @param n raw comorbidity count
 */
export function toComorbidity(n: string): KeyedDimension {
    if (n == null || n === "Unk") {
        return comorbidities.unknown;
    }

    switch (n) {
        case "0": return comorbidities.zero;
        case "1": return comorbidities.one;
        default: return comorbidities.twoPlus;
    }
}

/**
 * Compare a to b and return -1 when a is less than b, 0 when equal, 1 when a is greater than 0
 * @param a 
 * @param b 
 */
export const sort = (_: ISourceData, a: string, b: string): number => {
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export const createData = createCoreData;

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
export const addData = addDataFactory((vm: IDashboardSharedViewModel) => vm.comorbidityCount.name);
